import { defineCustomElement } from '../chunks/vidstack-BGSTndAW.js';
import { MediaAudioLayoutElement } from './templates/vidstack-audio-layout.js';
import { MediaVideoLayoutElement } from './templates/vidstack-video-layout.js';
import '../chunks/vidstack-DEzlvj53.js';
import '../chunks/vidstack-DJDnh4xT.js';
import '../chunks/vidstack-C2US-gSO.js';
import '@floating-ui/dom';
import 'lit-html';
import '../chunks/vidstack-Dq5Yu0Vr.js';
import 'lit-html/directives/if-defined.js';
import 'lit-html/directives/unsafe-svg.js';
import 'lit-html/async-directive.js';
import '../chunks/vidstack-DYbwIVLq.js';
import '../chunks/vidstack-BTM4ERc7.js';
import 'lit-html/directives/ref.js';
import '../chunks/vidstack-CTojmhKq.js';
import '../chunks/vidstack-xMS8dnYq.js';
import '../chunks/vidstack-CwTj4H1w.js';
import 'lit-html/directives/keyed.js';

defineCustomElement(MediaAudioLayoutElement);
defineCustomElement(MediaVideoLayoutElement);
